import { render, staticRenderFns } from "./add-year.vue?vue&type=template&id=14b01275&scoped=true"
import script from "./add-year.vue?vue&type=script&lang=js"
export * from "./add-year.vue?vue&type=script&lang=js"
import style0 from "./add-year.vue?vue&type=style&index=0&id=14b01275&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b01275",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b01275')) {
      api.createRecord('14b01275', component.options)
    } else {
      api.reload('14b01275', component.options)
    }
    module.hot.accept("./add-year.vue?vue&type=template&id=14b01275&scoped=true", function () {
      api.rerender('14b01275', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/creatProduct/add-year.vue"
export default component.exports